<template>
  <div
    id="inside"
    style="background-color: #f5f6fa !important"
  >
    <div v-bind:class="largura > 500 ? 'container' : ''">
      <div class="row d-flex justify-content-center px16 my16">
        <div class="px-0 col-lg-12">
          <div class="stepper-wrapper">
            <div class="stepper-item active">
              <div class="step-counter">1</div>
            </div>
            <div class="stepper-item">
              <div class="step-counter">2</div>
            </div>
            <div class="stepper-item">
              <div class="step-counter">3</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-12 mt-3">
        <div class="row">
          <div class="col-lg-12">
            <h5 class="mb-1 text-primary" style="font-weight: bold">
              Olá, {{ fullName ? fullName : '' }}!
            </h5>
            <h6 class="mb-0" style="color: #3a4148; font-weight: 600">
              Contratos disponíveis
            </h6>
            <p class="mb-0" style="color: #3a4148; font-weight: 400; font-style: italic">
              Veja aqui as informações disponíveis para negociar seus débitos
            </p>
          </div>
        </div>
      </div>
    </div>
    <nav class="navbar3 navbar-light navbar-expand" v-if="!loading">
      <button
        class="navbar-toggler navbar-toggler-right border-0"
        type="button"
        data-toggle="collapse"
        data-target="#navbar3"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        class="collapse navbar-collapse text-center justify-content-center"
        id="navbar3"
        style="width: 100%"
      >
        <ul class="navbar-nav justify-content-between">
          <li class="nav-item border-bottom border-info mx-5 mb-2">
            <a class="nav-link active" style="cursor: pointer">Propostas</a>
          </li>
          <li class="nav-item mx-5">
            <a class="nav-link" style="cursor: pointer">Acordos</a>
          </li>
        </ul>
      </div>
    </nav>

    <div>
      <ProgressLoading v-bind:loading="loading" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  formatCurrencieValueBRL as formatValue,
  formatData,
  formatDocument,
} from "@/utils/helpers";
import ProgressLoading from "./ProgressLoading.vue";
import { ActionGetIPAddress } from "@/utils/helpers";
import { hasContacts, CONTACTS_NOT_FOUND_MESSAGE } from "@/utils/authContacts";

export default {
  name: "HistoricoPagamentos",
  components: {
    ProgressLoading,
  },
  data() {
    return {
      loading: false,
      largura: null,
      accessdoc: null,
      promoCode: null,
      accessdocFormated: null,
      userIdAdm: null,
      fullName: null,
      ipUser: null,
    };
  },
  methods: {
    formatValue,
    formatData,
    formatDocument,

    ...mapActions("auth", [
      "ActionGetLinkAccessAsDebtor",
      "ActionGetContactsByDocNumber",
      "ActionDoLogout",
      "ActionDoLogin",
      "ActionSetCurrentForm",
    ]),

    async verifyIfIsAccessLinkAdmAsDebtor(infoEncrypted) {
      this.loading = true;
      
      try {
        var result = await this.ActionGetLinkAccessAsDebtor({
          infoEncrypted: infoEncrypted,
          IP: this.ipUser ? this.ipUser : "",
        });

        console.log("ActionGetLinkAccessAsDebtor result:" + JSON.stringify(result));

        // Verifica se o resultado é válido - a resposta vem com { code, error, message, results: [...] }
        if (!result || result.error || !result || result.length === 0) {
          console.error("Resultado inválido da API:", result);
          this.flashMessage.show({
            timeout: 1000,
            status: "error",
            position: "top right",
            title: "Erro",
            message: result?.message || "Não foi possível obter os dados do devedor.",
          });
          this.loading = false;
          return;
        }

        // Os dados estão em result.results[0]
        var data = result[0];
        this.accessdoc = data.DocNumber;
        this.promoCode = data.PromoCode; // Pode ser string vazia ""
        this.fullName = data.FullName;
        this.accessdocFormated = this.formatarCnpjCpf(this.accessdoc);
        const userAdm = {
          UserID: data.UserID,
          UserFullName: data.UserFullName,
        };

        localStorage.setItem("userAdm", JSON.stringify(userAdm));

        console.log("Dados obtidos - DocNumber:", this.accessdoc, "PromoCode:", this.promoCode);

        // PromoCode pode ser string vazia, então só verificamos se DocNumber existe
        if (this.accessdoc) {
          await this.doLogin(
            this.accessdoc,
            this.promoCode, // Passa mesmo se for string vazia
            userAdm.UserID,
            userAdm.UserFullName
          );
        } else {
          console.error("DocNumber não encontrado");
          this.flashMessage.show({
            timeout: 1000,
            status: "error",
            position: "top right",
            title: "Erro",
            message: "Documento não encontrado.",
          });
          this.loading = false;
        }
      } catch (error) {
        console.error("Erro em verifyIfIsAccessLinkAdmAsDebtor:", error);
        this.flashMessage.show({
          timeout: 1000,
          status: "error",
          position: "top right",
          title: "Erro",
          message: "Ocorreu um erro ao processar os dados.",
        });
        this.loading = false;
      }
    },

    async doLogin(accessdoc, promocode, userId, userFullName) {
      console.log("doLogin iniciado - accessdoc:", accessdoc, "promocode:", promocode);
      
      try {
        let response = await this.ActionGetContactsByDocNumber({
          DocNumber: accessdoc,
          OS: navigator.platform,
          UserID: userId,
          UserFullName: userFullName,
          IP: this.ipUser ? this.ipUser : "",
        });

        console.log("ActionGetContactsByDocNumber response:", response);

        if (!response || !response.data) {
          console.error("Resposta inválida de ActionGetContactsByDocNumber");
          this.loading = false;
          return;
        }

        if (response.data?.error) {
          this.flashMessage.show({
            timeout: 1000,
            status: "error",
            title: "Ocorreu um erro",
            message: response.data.message || CONTACTS_NOT_FOUND_MESSAGE,
          });
          this.loading = false;
          return;
        }

        if (!hasContacts(response.data.results)) {
          this.flashMessage.show({
            timeout: 1000,
            status: "error",
            title: "Ocorreu um erro",
            message: CONTACTS_NOT_FOUND_MESSAGE,
          });
          this.loading = false;
          return;
        }

        this.loading = true;
        // DebtorID pode não vir na resposta (Tribanco/Tricard não expõem mais esse campo
        // por segurança) — o backend resolve o devedor por DocNumber quando DebtorID faltar.
        let debtorId = response.data.results.DebtorID;
        let promoCode = promocode;

        console.log("Chamando ActionDoLogin - DebtorID:", debtorId);

        await this.ActionDoLogin({
          DebtorID: debtorId,
          DocNumber: accessdoc,
          PromoCode: promoCode,
          device_name: process.env.VUE_APP_API_DEVICE,
          OS: navigator.platform,
          UserID: userId,
          UserFullName: userFullName,
          IP: this.ipUser ? this.ipUser : "",
        });

        console.log("ActionDoLogin concluído com sucesso");

        localStorage.setItem(
          "authUser",
          JSON.stringify(this.$store.state.auth.user)
        );

        console.log("Redirecionando para dashboard...");
        this.$router.push({ name: "dashboard" });
      } catch (error) {
        console.error("Erro em doLogin:", error);
        this.flashMessage.show({
          timeout: 1000,
          status: "error",
          title: "Ocorreu um erro",
          message: "Erro ao autenticar, promocode incorreto ou inválido",
        });
      } finally {
        this.loading = false;
      }
    },

    formatarCnpjCpf(cnpjCpf) {
      if (!cnpjCpf) return '';
      
      // Remove formatação existente mas mantém letras para CNPJ alfanumérico
      const cleanValue = cnpjCpf.replace(/[.\-/]/g, '').toUpperCase();

      // CPF: 11 dígitos numéricos
      if (cleanValue.length === 11 && /^\d{11}$/.test(cleanValue)) {
        return cleanValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      } 
      // CNPJ: 14 caracteres (pode ser alfanumérico conforme IN RFB nº 2.119/2022)
      else if (cleanValue.length === 14) {
        return cleanValue.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, "$1.$2.$3/$4-$5");
      } else {
        return cnpjCpf;
      }
    },

    async getIPAddressUser() {
      let maxAttempts = 10;
      let attempts = 0;

      while (attempts < maxAttempts) {
        try {
          this.ipUser = await ActionGetIPAddress();
          break;
        } catch (error) {
          console.log("Erro ao obter o endereço IP. Tentando novamente...");
          attempts++;
          await new Promise((resolve) => setTimeout(resolve, 1000));
        }
      }

      if (attempts === maxAttempts) {
        console.log(
          "Número máximo de tentativas atingido. Não foi possível obter o endereço IP."
        );
      }
    },
  },
  async created() {
    await this.getIPAddressUser();
    this.loading = true;
    this.largura = window.screen.width;
    var infoEncrypted = localStorage.getItem("infoEncrypted");

    if (!infoEncrypted) {
      this.flashMessage.show({
        timeout: 300,
        status: "error",
        position: "top right",
        title: "Erro",
        message: "Não foi possível acessar informações do devedor.",
      });
      return;
    }

    this.verifyIfIsAccessLinkAdmAsDebtor(infoEncrypted);
  },
  computed: {
    ...mapState("auth", ["user"]),
    isLoggedIn() {
      return this.$store.getters["auth/isLoggedIn"];
    },
  },
};
</script>
<style scoped>
  html {
    height: 100dvh;
  }
</style>